export const SITE_URL = 'https://www.ccchoreography.org'
export const SITE_NAME = 'CC Choreography'
export const DEFAULT_OG_IMAGE = `${SITE_URL}/apple-touch-icon.png`
export const DEFAULT_LOCALE = 'en_AU'

export const CONTACT = {
  email: 'chelsea@ccchoreography.org',
  phone: '+61-403-406-529',
  phoneDisplay: '0403 406 529',
}

export const LOCATIONS = [
  {
    name: 'CC Choreography – Hamilton North',
    streetAddress: 'Unit 23/54 Clyde St',
    addressLocality: 'Hamilton North',
    addressRegion: 'NSW',
    postalCode: '2292',
    addressCountry: 'AU',
  },
  {
    name: 'Tiny Tutus – Lambton',
    streetAddress: '27 Wyong Rd',
    addressLocality: 'Lambton',
    addressRegion: 'NSW',
    postalCode: '2299',
    addressCountry: 'AU',
  },
]
